<template>
  <transition @enter="enter" appear>
    <div class="Support" :class="{ use_open: use_open }"> 
      <div class="Support__header">
        <div class="Support__button" :class="{ 'is-close': close }" @click="onClick()">   
          <div class="Support__icon">
            <svg viewBox="0 0 24.93 24.93">
              <rect class="cls-1" x="13.71" y="9.71" width="11.21" height="1.48" transform="translate(38.67 20.82) rotate(179.78)"/>
              <rect class="cls-1" x="13.74" y="13.7" width="1.48" height="11.22" transform="translate(29.04 38.56) rotate(179.76)"/>
              <rect class="cls-1" x="0.01" y="13.75" width="11.21" height="1.48" transform="translate(11.28 28.95) rotate(179.78)"/>
              <rect class="cls-1" x="9.71" y="0.01" width="1.48" height="11.26" transform="translate(20.91 11.24) rotate(179.76)"/>
              <path class="cls-1" d="M13.67,0a1.57,1.57,0,0,1,1.48,1.56l0,6H13.69Z"/>
              <path class="cls-1" d="M0,11.31A1.58,1.58,0,0,1,1.57,9.83l6,0v1.48Z"/>
              <path class="cls-1" d="M17.37,13.7l7.56,0a1.58,1.58,0,0,1-1.57,1.48l-6,0Z"/>
              <path class="cls-1" d="M11.26,24.93a1.57,1.57,0,0,1-1.48-1.56l0-6h1.48Z"/>
            </svg>
          </div>
          <div class="Support__close">Close</div>
        </div>
      </div>
      <div class="Support__container" :class="{ 'is-close': close }">
        <div class="Support__background">
          <img :src="require('@/commons/img/grid.png')">
        </div>
        <div class="Support__title" v-html="trans('GLOBAL.support')"/>
        <div ref="sub" class="Support__sub">
          <div class="Support__shadow">
            <img :src="require('@/commons/img/line.png')">
          </div>  
          <div ref="description" class="Support__description" v-html="trans('GLOBAL.support_description_large')"/>
          <div 
            ref="website" 
            class="Button over Support__btn" 
            @click="onTouch('services')">
            <div>View Services</div>
          </div> 
          <div 
            ref="services" 
            class="Button Support__btn" 
            @click="onTouch('web')">
            <div>Visit Web Experience</div>
          </div> 
        </div>
        <transition name="Support__web">
          <div class="Support__web" v-html="trans('GLOBAL.conclusion')" v-if="use_web"/>
        </transition>
        <BackButton v-if="use_web"/>
      </div>
    </div> 
  </transition>
</template>

<script>

import gsap from "gsap"
import BackButton from "./assets/BackButton.vue"

export default {
  name: 'Support', 
  components: { BackButton },
  data: ()=>({
    close: true,
    use_open: false,
    use_web: false,
    option: ''
  }),
  watch: {
    '$route': {
      immediate: true,
      handler() {
        if(this.$root.route.to.params.section == 'support')
          this.close = false
        else 
          this.close = true
        if(!this.close){
          this.use_open = true
          gsap.from(this.$refs.sub, {
            duration: .35,
            opacity: 0,
            delay: .75,
            ease: 'none',   
          })
        } else {
          gsap.delayedCall(.5, ()=> this.hideWeb())
        }
      },
    }, 
    close(nw) {
      this.motionButton(this.close)
    },
  },
  mounted() {
    const size = Math.round(window.innerHeight*.1)
    gsap.set('.Support__header', { height: size })
    if(window.innerHeight > 720)
      this.option = '_large'
  },
  methods:{
    enter(el, done) {
      gsap.from(this.$el, { 
        duration: .5,
        x: 200,
        ease: 'cubic.out', 
        delay: .05, 
        onComplete: ()=> done() 
      })

    },
    onClick() {
      if(this.close)
        this.$router.push({ params: { section: 'support' } })
      else if(this.$root.route.from.params.section != undefined 
           && this.$root.route.from.params.section != 'support')
        this.$router.push({ params: { section: this.$root.route.from.params.section } })
      else
        this.$router.push({ params: { section: undefined } })
    }, 
    onTouch(call) {
      if(call == 'services') 
        window.open('https://worldbankgroup.sharepoint.com/sites/wbunits/ijs/Pages/index.aspx', '_blank')

      // https://worldbankgroup.sharepoint.com/sites/wbunits/ijs/Pages/index.aspx
      // https://worldbankgroup.sharepoint.com/sites/wbunits/ijs/Pages/index.aspx (edited) 

      else if(call == 'web')
        this.switchToWeb()
        // window.open('https://trace.worldbank.org', '_blank')

    },

    switchToWeb() {
      gsap.to(['.Support__title', '.Support__sub'], {
        opacity: 0,
        duration: .25,
        ease: 'none',
        onComplete: ()=>{
          this.use_web = true
        }
      })
    },

    hideWeb() {

      this.use_web = false
      gsap.to(['.Support__title', '.Support__sub'], {
        opacity: 1,
        duration: .25,
        delay: .25,
        ease: 'none'
      })

    },

    motionButton(b) {
      let tml
      if(!b)
        tml = gsap.timeline({})
        .add([ gsap.to('.Support__icon', { duration: .5, rotation: '+=180', ease: 'back.out' }), gsap.to('.Support__close', { opacity: 1, delay: .25 }), gsap.to('.Support__button', { duration: .6, width: '30%', ease: 'back.out' }) ])
      else 
        tml = gsap.timeline({ onComplete: ()=>{ this.use_open = false } })
        .add([ gsap.to('.Support__icon', { duration: .75, rotation: '-=180', ease: 'back.out' }), gsap.to('.Support__close', { opacity: 0, duration: .25 }),
          gsap.to('.Support__button', { duration: .5, width: '15%', ease: 'cubic.out' }) ])
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Support
  position absolute
  top 0
  left 0
  width 100% 
  height auto
  z-index 10000

  &.use_open 
    height 100%

  &__header 
    width 100%
    height 100%
    display flex
    align-items center
    justify-content flex-end

  &__button
    color white
    background purple
    width 15vw
    height 32px
    border-radius 22px
    cursor pointer
    margin-right 16px
    display flex
    justify-content flex-end
    align-items center 
    position relative

  &__container

    // background rgb(179,204,52)
    // background linear-gradient(0deg, rgba(179,204,52,1) 64%, rgba(141,163,29,1) 100%)
    
    background rgb(78, 60, 153)
    background linear-gradient(0deg, rgba(78, 60, 153, 1) 40%, rgba(32, 37, 42, 1) 100%)
    position absolute
    top 0vh
    left 0
    width 100%
    height 90%

    margin-top 10vh
    border-top-left-radius 36px
    border-top-right-radius 36px
    transition transform .5s
    overflow hidden

    display flex
    flex-direction column
    align-items center
    justify-content flex-start
   
    &.is-close 
      transform translateY(100vh)

  &__background 
    position absolute

    & img 
      width 1312px
      max-width none
      top 0

  &__shadow 
    position absolute
    height 2px
    display flex 
    z-index 40000

  &__icon 
    width 4vw
    height 4vw
    position absolute
    transform-origin 50 50
    right 5vw

  .cls-1
    fill #fff

  &__title
    color white
    padding-top 14%  
    width 100%
    text-align center

    font-size 2.13em
    line-height 1.15em
    font-family SpaceGrotesk
    font-weight 400
    padding-bottom 8%  

    & span 
      font-weight 900

  &__description
  &__web 
    color white
    text-align center
    padding 32px 10% 16px 
    line-height 1.43em
    & span 
      font-weight 900

  &__close
    position absolute
    left 40%
    transform translateX(-50%)
    opacity 0

  &__sub 
    height 68%
    padding-bottom 32px  
    overflow-Y scroll
    z-index 3000
    display flex 
    flex-direction column
    align-items center

  &__btn 
    padding 16px 0 
    margin 16px 0 0px

  &__web 
    position absolute
    width 80vw
    top 50%
    transform translateY(-50%)
    transition transform .5s, opacity .5s

    &-enter 
      transform translateY(200px)
      opacity 0
    &-leave-active
      opacity 0

</style>


